import { gql, TypedDocumentNode } from '@apollo/client';

import { SearchInput, SearchResultsType } from '@atom/types/search';

export const BASE_SEARCH_RESULTS = gql`
  fragment BaseSearchResults on SearchResults {
    assets {
      id
      schemaId
      externalId
      name
      assetType
      markerId
      colorId
      isMaterial
      locationType
      categoryPath
      isSubItem
      ancestors {
        id
        name
      }
      location {
        coordinates
        type
      }
      grants {
        type
        ids
      }
      budget {
        isStockBased
        rate
        unit
      }
    }
    workOrders {
      id
      name
      statusId
    }
    users {
      id
      firstName
      lastName
      email
      photoUrl
    }
  }
`;

export const GET_SEARCH_RESULTS: TypedDocumentNode<
  { search: SearchResultsType },
  { input: SearchInput }
> = gql`
  query search($input: SearchInput!) {
    search(input: $input) {
      ...BaseSearchResults
    }
  }
  ${BASE_SEARCH_RESULTS}
`;
